import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingLayout from "../../components/layout/OnboardingLayout";
import TextInput from "../../components/formInputs/TextInput";
import Checkbox from "../../components/formInputs/Checkbox";
import Button from "../../components/buttons/Button";
import UserIcon from "../../components/icons/UserIcon";
import "../../components/styles/profileSetupPage.scss";

/**
 * ProfileSetupPage — "Who is watching" (Onboarding Step 4)
 * Figma: 1.4 Onboarding(Desktop) (24654:6649)
 *
 * Stepper: currentStep=3 (Setting an account — active)
 * Content:
 *   - Title: "Who is watching" (36px/600 Poppins, #fafafa)
 *   - Subtitle: "Create your platform and customize..." (20px/400, #a3a3a3)
 *   - "Your profile" section (28px/600, white)
 *     - Name input (filled: "Dean lewis", full width, UserIcon + Close icon)
 *   - "Other profile" section (28px/600, white)
 *     - Header row: "Other profile" left + "Kids" right (24px/600)
 *     - Input rows: TextInput (flex:1) + Checkbox (no text, 32x32), gap 40px
 *     - Two rows: "e.g khannedy" and "e.g mason"
 *   - Continue button (self-aligned right, 16px/600 SemiBold)
 */
const ProfileSetupPage = () => {
  const navigate = useNavigate();
  const [mainProfile, setMainProfile] = useState("Dean lewis");
  const [kidProfile1, setKidProfile1] = useState("");
  const [kidProfile2, setKidProfile2] = useState("");
  const [isKid1, setIsKid1] = useState(false);
  const [isKid2, setIsKid2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = useCallback(() => {
    if (isLoading) return;
    setIsLoading(true);

    // TODO: Replace with actual profile setup API call
    setTimeout(() => {
      setIsLoading(false);
      navigate("/onboarding/personalize");
    }, 1500);
  }, [isLoading, navigate]);

  return (
    <OnboardingLayout
      currentStep={3}
      title="Who is watching"
      subtitle="Create your platform and customize it according to your preferences so we can recommend events according to your profile."
      actions={
        <Button
          label="Continue"
          size="md"
          variant="primary"
          isLoading={isLoading}
          action={handleContinue}
          className="mango-btn--auto-width"
        />
      }
    >
      {/* Form Group — Figma: flex-col gap 36px */}
      <div className="profile-setup__form-group">
        {/* Your Profile Section — Figma: flex-col gap 28px */}
        <div className="profile-setup__section">
          <h2 className="profile-setup__section-title">Your profile</h2>
          <TextInput
            value={mainProfile}
            onChange={setMainProfile}
            placeholder="Enter your name"
            leftIcon={<UserIcon />}
          />
        </div>

        {/* Other Profile Section — Figma: flex-col gap 28px */}
        <div className="profile-setup__section">
          {/* Label row — Figma: justify-between, "Other profile" 28px + "Kids" 24px */}
          <div className="profile-setup__section-header">
            <h2 className="profile-setup__section-title">Other profile</h2>
            <h3 className="profile-setup__section-subtitle">Kids</h3>
          </div>

          {/* Input rows — Figma: flex-col gap 20px */}
          <div className="profile-setup__rows">
            {/* Row 1 — Figma: flex gap 40px, items-center */}
            <div className="profile-setup__row">
              <div className="profile-setup__row-input">
                <TextInput
                  value={kidProfile1}
                  onChange={setKidProfile1}
                  placeholder="e.g khannedy"
                  leftIcon={<UserIcon />}
                />
              </div>
              <Checkbox
                checked={isKid1}
                onChange={setIsKid1}
              />
            </div>

            {/* Row 2 — Figma: flex gap 40px, items-center */}
            <div className="profile-setup__row">
              <div className="profile-setup__row-input">
                <TextInput
                  value={kidProfile2}
                  onChange={setKidProfile2}
                  placeholder="e.g mason"
                  leftIcon={<UserIcon />}
                />
              </div>
              <Checkbox
                checked={isKid2}
                onChange={setIsKid2}
              />
            </div>
          </div>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default ProfileSetupPage;
